<template>
  <b-modal
    ref="modal-operations-lis-services-for-travel"
    :title="getTitle"
    title-tag="h4"
    modal-class="modal-primary"
    size="xmd"
    scrollable
    no-close-on-backdrop
    @hidden="$emit('hideModal')"
  >
    <b-table-simple
      small
      responsive
      class="font-small-3"
      sticky-header="50vh"
      selectable
      select-mode="multi"
      ref="operations-services-without-travel-table"
    >
      <b-thead>
        <b-tr>
          <b-th>
            <b-form-checkbox
              @change="selectAll"
              v-model="isAllSelected"
            ></b-form-checkbox>
          </b-th>
          <b-th> {{ $t("Service") }} </b-th>
          <b-th class="text-center"> Qty O.D. </b-th>
          <b-th class="text-center"> {{ $t("Quantity") }} </b-th>
          <b-th class="text-center"> {{ $t("Volume") }} </b-th>
          <b-th class="text-center"> {{ $t("Weight") }} </b-th>
        </b-tr>
      </b-thead>

      <b-tbody>
        <template v-for="(service, key) in service_orders">
          <b-tr :key="key">
            <b-td>
              <b-form-checkbox
                @change="checkedService"
                v-model="service.isSelected"
              >
              </b-form-checkbox>
            </b-td>
            <b-td>
              <div class="d-flex flex-column">
                <span class="text-primary"> {{ service.service_order }} </span>
                <span>
                  <tabler-icon icon="UserIcon" class="text-warning" />
                  <span v-if="service.business_name != null">{{
                    service.business_name
                  }}</span>
                  <span v-else> {{ $t("Client not found") }} </span>
                </span>
              </div>
            </b-td>
            <b-td class="text-info text-center">
              <b-badge variant="light-info">
                {{ service.qty_documents }}
              </b-badge>
            </b-td>
            <b-td class="text-info text-center"> {{ service.quantity }} </b-td>
            <b-td class="text-primary text-center">
              {{ service.volume.toFixed(3) }}
            </b-td>
            <b-td class="text-warning text-center">
              {{ service.weight.toFixed(3) }}
            </b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>

    <b-card :bg-variant="isDarkSkin ? 'black' : 'white'" class="mb-0">
      <div class="d-flex justify-content-between">
        <div>
          {{ $t("Services selected") }} :
          <span class="text-primary"> {{ getTotalSelected }} Items </span>
        </div>
        <div>
          {{ $t("Quantity") }} :
          <span class="text-info"> {{ getTotalQuantitySelected }} </span>
        </div>
        <div>
          {{ $t("Volume") }} :
          <span class="text-primary"> {{ getTotalVolumeSelected }} M3 </span>
        </div>
        <div>
          {{ $t("Weight") }} :
          <span class="text-warning"> {{ getTotalWeightSelected }} </span>
        </div>
      </div>
    </b-card>
    <template #modal-footer>
      <div class="d-flex align-items-center justify-content-end">
        <b-button variant="outline-danger" @click="$emit('hideModal')">
          {{ $t("Cancel") }}
        </b-button>
        <b-button
          variant="outline-primary"
          class="ml-1"
          @click="addServicesToTravel"
        >
          {{ $t("Add") }}
        </b-button>
      </div>
    </template>
  </b-modal>
</template>

<script>
import modalMixin from "@/mixins/modal";
import Ripple from "vue-ripple-directive";
import { mapGetters } from "vuex";

import ServiceOrdersService from "@/views/operations/views/service-orders/services/service-orders.service";

export default {
  mixins: [modalMixin],
  directives: {
    Ripple,
  },
  components: {},
  props: {
    travelId: {
      default: null,
    },
    currentServices: {
      default: [],
    },
  },
  data() {
    return {
      minDate: new Date(1000, 1, 1),
      maxDate: new Date(2050, 9, 1),
      finishedLoading: false,
      service_orders: [],
      addServicesModal: false,
      isAllSelected: false,
    };
  },
  mounted() {
    this.toggleModal("modal-operations-lis-services-for-travel");
  },
  async created() {
    this.addPreloader();
    this.finishedLoading = false;
    try {
      await Promise.all([this.getServicesWithoutTravel()]);
    } catch (error) {
      console.log(error);
    } finally {
      this.finishedLoading = true;
      this.removePreloader();
    }
  },
  computed: {
    ...mapGetters({
      currentUser: "auth/currentUser",
    }),

    getTitle() {
      return "Create travel order".toLocaleUpperCase();
    },

    getTotalSelected() {
      return this.service_orders.filter((service) => service.isSelected).length;
    },

    getTotalQuantitySelected() {
      let quantity = 0;
      this.service_orders.map((service) => {
        if (service.isSelected) quantity += service.quantity;
      });

      return quantity;
    },

    getTotalVolumeSelected() {
      let volume = 0;
      this.service_orders.map((service) => {
        if (service.isSelected) volume += service.volume;
      });
      return parseFloat(volume.toFixed(3));
    },

    getTotalWeightSelected() {
      let weight = 0;
      this.service_orders.map((service) => {
        if (service.isSelected) weight += service.weight;
      });
      return parseFloat(weight.toFixed(3));
    },
  },
  methods: {
    async getServicesWithoutTravel() {
      try {
        const { data } = await ServiceOrdersService.getServicesWithoutTravel();
        if (this.currentServices.length) {
          data.map((service) => {
            if (this.currentServices.includes(service.service_id)) {
              service.isSelected = true;
            }
            return service;
          });
        }
        this.service_orders = data;
      } catch (error) {
        throw error;
      }
    },

    selectAll() {
      if (this.isAllSelected === true) {
        this.service_orders.map((service) => {
          service.isSelected = true;
          return service;
        });
      } else {
        this.service_orders.map((service) => {
          service.isSelected = false;
          return service;
        });
      }
    },

    addServicesToTravel() {
      const services = this.service_orders.filter(
        (service) => service.isSelected
      );

      this.$emit("addServices", services);
    },

    checkedService(val) {
      if (!val) this.isAllSelected = false;
      // this.isAllSelected = false;
    },

    closeSidebar(action) {
      this.$emit("hideSidebar", action);
    },

    positionDropdown(dropdownList, component, { width, top, left }) {
      dropdownList.style.zIndex = 9999;
      dropdownList.style.maxHeight = "20rem";
      dropdownList.style.top = top;
      dropdownList.style.left = left;
      dropdownList.style.width = width;
    },
  },
};
</script>

<style>
</style>